export class PlanogramDetailsDto {
  id: string;
  planogramMainCategory: string;
  planogramCategory: string;
  planogramSubCategory: string;
  dimension: string;
  name: string;
  description: string;

  constructor(d?: PlanogramDetailsDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
